export default "__VITE_ASSET__7mRT$x2u__"